export const StatusCountCard: React.FC<{
    label: string;
    value: number;
    className: string;
    valueClassName: string;
    labelClassName: string;
}> = ({ label, value, className, valueClassName, labelClassName }) => {
    return (
        <div className={`text-center p-2 rounded border ${className}`}>
            <p className={`text-lg font-bold ${valueClassName}`}>{value}</p>
            <p className={`text-[10px] font-medium uppercase tracking-wide ${labelClassName}`}>
                {label}
            </p>
        </div>
    );
};